export default function FullPageLoader() {
    return (
        <div className="loader" style={{display: "block"}}>
            <div className="spinner">
                <div className="double-bounce1"></div>
                <div className="double-bounce2"></div>
            </div>
        </div>
    );
}
